import React, { useLayoutEffect } from 'react';

interface Props {
  title: string;
  children?: React.ReactNode;
}

// Shows the title in the browser tab while the view is rendered, and clears it afterwards.
const DocumentTitle: React.FC<Props> = ({ title, children }) => {
  useLayoutEffect(() => {
    document.title = title;
    return () => {
      document.title = '';
    };
  }, [title]);

  return <>{children}</>;
};

export default DocumentTitle;
